//@flow
import React from 'react';
import {commands} from '@uiw/react-md-editor';

import EmojiPicker from '../EmojiPicker/EmojiPicker';

import type {CommandChildProps} from './CustomTextEditor';
import type {TextState, TextAreaTextApi, ICommand} from '@uiw/react-md-editor';
import SmileIcon from '../icons/SmileIcon';

function EmojiCommandChildren(props: CommandChildProps) {
  const {close, textApi} = props;

  return (
    <EmojiPicker
      onEmojiPick={emoji => {
        textApi && textApi.replaceSelection(emoji.native);
        close();
      }}
    />
  );
}

export const emojiCommand: ICommand = commands.group([], {
  name: 'Emoji',
  enabled: true,
  keyCommand: 'emoji',
  groupName: 'emoji',
  buttonProps: {'aria-label': 'Insert an emoji'},
  icon: <SmileIcon />,
  children: (props: CommandChildProps) => <EmojiCommandChildren {...props} />,
  execute: (state: TextState, api: TextAreaTextApi) => {},
});
